import Vue from 'vue'

function defaultHttp () {
  return Vue.prototype.$http
}

Vue.prototype.$api = {
  userPermissions () {
    return {
      listAuthorized: () => defaultHttp().get('/api/user/permissions'),
    }
  },
  banks () {
    const resource = 'banks'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  branches () {
    const resource = 'branches'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },
  branchPaymentChannels () {
    const resource = 'branch-payment-channels'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/branches/${id}`, data),
      delete: (data) => defaultHttp().post(`/api/${resource}/delete`, data),
      overview: () => defaultHttp().get(`/api/${resource}-overview`),
      showBranchAccount: () => defaultHttp().get('/api/branch-account'),
    }
  },
  companies () {
    const resource = 'companies'
    return {
      list: () => defaultHttp().get(`/api/${resource}?include=companyTax.taxSetting`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      withSchema: () => defaultHttp().get(`/api/${resource}-has-schemas`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  companyQuotas () {
    const resource = 'company-quotas'
    return {
      list: (companyId = '', year = '', category = '') => defaultHttp().get(`/api/${resource}${companyId ? `?filter[company_id]=${companyId}&filter[year]=${year},${year - 1}&filter[category_id]=${category}` : ''}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      updateMany: (companyId, data) => defaultHttp().patch(`api/${resource}/companies/${companyId}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      overview: () => defaultHttp().get(`/api/${resource}-overview`),
    }
  },
  companyQuotaCategories () {
    const resource = 'company-quota-categories'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  fundBuckets () {
    const resource = 'fund-buckets'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  fundBucketItems () {
    const resource = 'fund-bucket-items'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      ids: (data) => defaultHttp().post('api/fund-bucket-item-ids', data),
      priorityIds: (data) => defaultHttp().post(`/api/${resource}-priority-ids`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      updateMany: (data) => defaultHttp().post(`/api/${resource}-update-many`, data),
      priorityUpdate: (data) => defaultHttp().post(`/api/${resource}-priority-update`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  fundBucketTypes () {
    const resource = 'fund-bucket-types'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
    }
  },
  fundBucketHasTypes () {
    const resource = 'fund-bucket-has-types'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  fundBucketItemDescriptions () {
    const resource = 'fund-bucket-item-descriptions'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  lookups () {
    const resource = 'lookups'
    return {
      list: (type = '', isActive = 1) => defaultHttp().get(`/api/${resource}${type ? `?filter[type]=${type}&filter[is_active]=${isActive}` : ''}`),
    }
  },
  paymentChannels () {
    const resource = 'payment-channels'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  paymentChannelTypes () {
    const resource = 'payment-channel-types'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  taxSettings () {
    const resource = 'tax-settings'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
}
